import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Tu libro ha sido de mucha bendición para mí. El tratar de estar en todo al mismo tiempo es un caos... tu libro me ha ayudado mucho en organizarme, en tener más control de todo sin que se me pase algo importante. Además ha mejorado mucho mi forma de comunicarme para que nuestras vidas no sean tan complejas.',
  author: 'Narce Espinoza, cuidadora 💙'
}, {
  quote: 'Es increíble cómo ha bajado mi salud desde que cuido a mi mamá. Necesitaba algo así.',
  author: 'Luz María C., Cuidadora'
}, {
  quote: 'Maravilloso. Es importante aprender a sostener sin culpa... y realmente es muy difícil.',
  author: 'Ericka C., Cuidadora'
}, {
  quote: 'Sumamente importante este apoyo. Deseo que llegue a muchas familias.',
  author: 'CEIVA, Comunidad de apoyo'
}];
export function Testimonial() {
  return <section className="py-14 px-4 bg-sage/10" data-id="element-437">
      <div className="max-w-5xl mx-auto" data-id="element-438">
        <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-2xl md:text-3xl font-serif font-bold text-navy text-center mb-10" data-id="element-439">
          Esto dicen quienes ya conocen este tema:
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-440">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-sm border border-navy/5 text-center space-y-4" data-id="element-441">
              <p className="text-lg md:text-xl font-serif italic text-navy/90 leading-relaxed" data-id="element-442">
                "{testimonial.quote}"
              </p>
              <p className="text-base text-navy/60 font-medium" data-id="element-443">
                — {testimonial.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}